module.exports = {"id":"193001","name":"Riad Nouri","rating":"72","photo":"./data/images/photos/3/193001.png","club":{"name":"AC Ajaccio","logo":"./data/images/clubs/ACAjaccio.png"},"positions":["MG","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RiadNouri0.json
// module id = 3584
// module chunks = 0